// extracted by mini-css-extract-plugin
export default {"SignInPage":"SignIn_SignInPage__3B5J2","SignInPage__body":"SignIn_SignInPage__body__3xgNI","SignInPage__navbar":"SignIn_SignInPage__navbar__3_3G9"};